import { FC, memo, useRef } from 'react'

import {
  Dropdown,
  DropdownController,
  Flex,
  FlexProps,
  Text,
  TextButton,
} from '@revolut-internal/ui-kit'

import { useVisibleElements } from 'hooks/useVisibleElements'
import { BarChartLegendItem } from 'types'

import { ChartLegendItem } from './ChartLegendItem'

type ChartLegendProps = {
  items: BarChartLegendItem[]
  containerProps?: FlexProps
}

export const ChartLegend: FC<ChartLegendProps> = memo(({ items, containerProps }) => {
  const wrapperRef = useRef(null)
  const { visibleIndex } = useVisibleElements({ wrapperRef })

  return (
    <Flex
      justifyContent="flex-end"
      alignItems="flex-end"
      height="100%"
      {...containerProps}
    >
      <Flex
        ref={wrapperRef}
        flex="1"
        gap="s-8"
        overflow="hidden"
        justifyContent="flex-end"
      >
        {items.map(item => (
          <ChartLegendItem key={item.value} item={item} />
        ))}

        <DropdownController>
          {dropdown => (
            <>
              <TextButton aria-haspopup="dialog" {...dropdown.getAnchorProps()}>
                <Text variant="emphasis3" whiteSpace="nowrap">
                  Show more
                </Text>
              </TextButton>
              <Dropdown
                role="dialog"
                aria-label="More"
                focusTrap
                closeOnEsc
                {...dropdown.getTargetProps()}
              >
                <Flex p="s-16" flexWrap="wrap" gap="s-8" justifyContent="flex-end">
                  {items.slice(visibleIndex + 1).map(item => (
                    <ChartLegendItem key={item.value} item={item} />
                  ))}
                </Flex>
              </Dropdown>
            </>
          )}
        </DropdownController>
      </Flex>
    </Flex>
  )
})
